import { useNavigate } from 'react-router-dom';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';

const DRTableItem = ({idx, resource, onDrDetail, onDelete, onEdit}) => {
  const navigate = useNavigate();

  return (
    <tr key={resource.DrResourceSysId}>
      <td className="charger-idx">{idx}</td>
      <td className="charger-id">{resource.ResourceName}</td>
      <td className="charger-location">{resource.DrType}</td>
      <td className="charger-location">{resource.RegionSido}</td>
      <td className="charger-location">{resource.Stations.length}</td>
      <td className="charger-location">{resource.Chargers.length}</td>
      <td className="charger-location">{resource.OpmContractInfos.length}</td>
      <td className="charger-location" width="200px">
        <p
          className='text-c1-400 text-gray-600 cursor-pointer text-underline'
          onClick={(e) => {
            e.stopPropagation();
            navigate(`./detail/${resource.DrResourceSysId}/opm-contracts`, { state: { from: 'list' } });
          }}
        >
          고객계약번호 별 인프라 정보
        </p>
      </td>
      <td className="charger-location" width="200px">
        <p
          className='text-c1-400 text-gray-600 cursor-pointer text-underline'
          onClick={(e) => {
            e.stopPropagation();
            navigate(`./detail/${resource.DrResourceSysId}`, { state: { from: 'list' } });
          }}
        >
          DR 자원 정보
        </p>
      </td>
      <td className='button-container' onClick={(e) => e.stopPropagation()}>
        <div className='flex align-center gap-5'>
          <button className='btn icon-btn' onClick={(e) => {e.stopPropagation(); onEdit(resource)}}>
            <EditIcon color='var(--gray-600)'/>
          </button>
          <button className='btn icon-btn' onClick={(e) => {e.stopPropagation(); onDelete(resource)}}>
            <DeleteIcon color='var(--gray-600)'/>
          </button>
        </div>
      </td>
    </tr>
  )
}

export default DRTableItem